import React from 'react'

const NotFoundPage = () => {
  return (
    <div>אדם חכם אמר פעם: "לעולם אל תסמוך על דף שאינך יכול למצוא"</div>
  )
}

export default NotFoundPage